import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5 10.41l7 7 9-9L19.59 7 12 14.59 6.41 9H11V7H3v8h2z"
}), 'CallMissedTwoTone');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CallMissedTwoTone.js
// module id = 2613
// module chunks = 2